import React, { useCallback } from 'react';
import { setDeviceSettingsKey } from 'actions/deviceSettings';
import { UpgradeWebModal } from 'design-system/UpgradeWebModal';
import FeatureCard from 'features/feed/components/FeatureCard';
import { Tier } from 'features/premium/entities';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { StyleSheet } from 'react-native';
import { rem } from 'design-system';
import { selectCreditScoreHasRealTimeUpdates } from '../selectors';
import { isWeb } from '../../../constants';
const strings = {
    title: 'Get credit reports on demand',
    description: 'Upgrade to Ultimate and your report updates the moment something changes, not just once a month',
    cta: 'Upgrade',
};
const THIRTY_DAYS_MS = 1000 * 3600 * 24 * 30;
const CreditReportRealTimeUpsellCard = () => {
    const dispatch = useAppDispatch();
    const navigation = useMainStackNavigation();
    const hasRealTimeUpdates = useAppSelector(selectCreditScoreHasRealTimeUpdates);
    const lastTimeDismissed = useAppSelector((store) => store.deviceSettings.lastTimeDismissCreditScoreRealTimeUpsell);
    const recentlyDismissed = lastTimeDismissed !== undefined &&
        Date.now() - lastTimeDismissed < THIRTY_DAYS_MS;
    const onPressUpgrade = useCallback(() => {
        if (isWeb) {
            UpgradeWebModal.show(Tier.ultimate);
            return;
        }
        navigation.navigate('EmmaProModal', { tier: Tier.ultimate });
    }, [navigation]);
    const onDismiss = useCallback(() => {
        dispatch(setDeviceSettingsKey('lastTimeDismissCreditScoreRealTimeUpsell', Date.now()));
    }, [dispatch]);
    if (hasRealTimeUpdates)
        return null;
    // Collapsible is a no-op View on web, so isCollapsed wouldn't hide the
    // card — unmount instead once dismissed.
    if (isWeb && recentlyDismissed)
        return null;
    if (isWeb && recentlyDismissed)
        return null;
    return (<FeatureCard title={strings.title} description={strings.description} noDescriptionMargin cta={strings.cta} onPressCta={onPressUpgrade} onPressCancel={onDismiss} isCollapsed={recentlyDismissed} style={styles.upgradeCard}/>);
};
export default CreditReportRealTimeUpsellCard;
const styles = StyleSheet.create({
    upgradeCard: {
        marginBottom: rem(0),
        marginTop: rem(16),
    },
});
